<template>
  <span @click="copyToClipboard(text)" class="copy-to-clipboard">
    <fa-icon :icon="['fal', 'copy']" /><span v-if="displayText" class="ml-2">{{ displayText }}</span>
  </span>
</template>
<script>
import { copyToClipboard } from '@/common/utils'

export default {
  props: {
    text: {type: String, required: true},
    displayText: {type: String, required: false, default: ''}
  },
  methods: {
    copyToClipboard
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/CopyToClipboard.vue